import React from "react";
import {reporting, onPerceivedRender} from "@core-ui/reporting";
import CatProductImage from "@cat/product-image";
import {ProductImage} from "@core-ui/product-image";
import QuickAdd from "@cat/quick-add";
import {HighPriorityEvent, ProductImageDefaultProps} from "./types";

const cat1ImageLoaded = (
  highPriorityEvents: Array<HighPriorityEvent>
): void => {
  const cat1LoadedEvent = highPriorityEvents.find(
    ({name}) => name === "cat1ImageLoaded"
  );
  onPerceivedRender().then(() => {
    // eslint-disable-next-line no-console
    console.timeStamp && console.timeStamp("Cat 1st img loaded");

    if (!window.gap.isCat1ImageLoadedSent && cat1LoadedEvent) {
      window.gap.isCat1ImageLoadedSent = true;
      reporting("cat1ImageLoaded", "cat1ImageVersion", "componentMode");
      cat1LoadedEvent.deferred.resolve("cat1ImageLoaded");
    }
  });
};

const Image = ({
  alt = "",
  hoverAlt,
  hoverSrc,
  id,
  index,
  market = "US",
  name,
  onClick,
  src = "",
  highPriorityEvents = [],
  isQuickAddEnabled,
  productUrl,
  useRatio = true,
  reviewCount,
  starRating,
}: ProductImageDefaultProps): JSX.Element => {
  const handleCat1ImageLoad = (): void => {
    if (index === 0) {
      cat1ImageLoaded(highPriorityEvents);
    }
  };

  if (isQuickAddEnabled) {
    return (
      <CatProductImage
        alt={alt}
        className="product-card__image"
        highPriorityEvents={highPriorityEvents}
        hoverAlt={hoverAlt}
        hoverSrc={hoverSrc}
        index={index}
        market={market}
        onClick={onClick}
        productUrl={productUrl}
        src={src}
        useRatio={useRatio}
      >
        <QuickAdd
          productId={id}
          productName={name}
          reviewCount={reviewCount}
          starRating={starRating}
        />
      </CatProductImage>
    );
  }

  return (
    <ProductImage
      alt={alt}
      className="product-card__image"
      hoverAlt={hoverAlt}
      hoverSrc={hoverSrc}
      onClick={onClick}
      onLoad={handleCat1ImageLoad}
      productUrl={productUrl}
      src={src}
      useRatio={useRatio}
    />
  );
};

export default Image;
